import { BaseFormComponent } from '../base/base-form.component';
import { Component } from '@angular/core';

/**
 * 雙檔明細 Dialog 頁面的抽象類別，繼承 BaseFormComponent。
 *
 * @export
 * @abstract
 * @class SimpleDoubleDetailComponent
 * @extends {BaseFormComponent}
 */
@Component({
  template: ''
})
export abstract class SimpleDoubleDetailComponent extends BaseFormComponent {

  /**
   * 雙檔明細維護直接就是編輯狀態，不需要有 MenuBar。
   */
  override hasMasterMenuBar: boolean = false;

  /**
   * 雙檔明細維護直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override async doMasterMenuSubmit(): Promise<boolean> {
    return true;
  }

  /**
   * 雙檔明細維護直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override async beforeMasterMenuSubmit(): Promise<boolean> {
    return true;
  }

  /**
   * 雙檔明細維護直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override async doMasterMenuDelete(): Promise<boolean> {
    return true;
  }

  /**
   * 雙檔明細維護直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override async beforeMasterMenuDiscard(): Promise<boolean> {
    return true;
  }

  /**
   * 雙檔明細維護直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override afterMasterMenuStatusChange(): void{
    return;
  }

  /**
   * 雙檔明細維護直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override initExtraMasterMenu(): void {
    return;
  }

  /**
   * 雙檔明細維護直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override setExtraMasterMenuStatus(): void {
    return;
  }

  /**
   * 放棄按下去後要做的事情。
   * (1) 跳出確認視窗確認是否不保存資料。
   * (2) 確認後直接關閉 Dialog。
   */
  discard(): void {
    this.systemConfirmationService.confirmDiscardChanges(() => {
      this.closeDialog();
    });
  }

  /**
   * 需要在儲存為草稿前做的事情，可以在這做一些額外的驗證。
   * 如果有做額外的驗證要配合 formGroup 的 valid，不然驗證到有錯還是會繼續執行。
   *
   * 如果沒有特別要做的事情，實作後直接 return 就可以。
   */
  abstract beforeSave(): Promise<boolean>;

  /**
   * 儲存為草稿按下去後要做的事情。
   * (1) 進行欄位驗證。
   * (2) 欄位驗證過後，顯示處理中遮罩。
   * (3) 確定所有 autoAomplete 欄位都做完驗證才呼叫 doSave() 進行儲存為草稿。
   * (4) 處理完後呼叫 afterSave()。
   */
  async save(): Promise<void> {
    this.loadingMaskService.show();
    const canSave: boolean = await this.beforeSave();
    if (canSave) {
      this.submitted = true;
      if (this.formGroup.valid) {
        this.waitAutoCompleteCompleted(
          async() => {
            // complete 後要實際去執行 doSave()
            await this.doSave();
            this.afterSave()
          }
        );
      } else {
        this.loadingMaskService.hide();
      }
    } else {
      this.loadingMaskService.hide();
    }
  }

  /**
   * 儲存為草稿要的事情。
   * 通常是要把 Form 表單裡的資料拼成要回傳到前一個畫面的資料，並寫到 masterData 內。
   *
   * 注意：
   * 請一定要把實際送出存檔後的資料寫入 this.masterData，因為關閉 Dialog 後會把資料回傳到前面顯示。
   */
  abstract doSave(): Promise<boolean>;

  /**
   * 儲存為草稿完畢後要做的事情。
   * (1) 處理 Dialog 回傳資料。
   * (2) 移除處理中遮罩。
   * (3) 關閉 Dialog。
   */
  afterSave(): void {
    console.log('SimpleDoubleDetailComponent afterSave');
    this.submitted = false;
    this.loadingMaskService.hide();
    this.dialogReturnDataAction = this.parentDataAction;
    this.closeDialog();
  }
}
